import React from "react";
import { GALLERY } from "@/lib/content";

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative py-24 md:py-32 bg-[#114b5f] text-[#faf9f6] overflow-hidden"
        >
            <div className="pointer-events-none absolute inset-0 gdc-grain" />
            <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative">
                <div className="lg:col-span-6 order-2 lg:order-1">
                    <div className="grid grid-cols-2 gap-4">
                        <img
                            src="https://images.pexels.com/photos/4269276/pexels-photo-4269276.jpeg"
                            alt="Modern dental operatory chair"
                            className="w-full h-72 md:h-80 object-cover object-center rounded-3xl"
                        />
                        <img
                            src={GALLERY[3]}
                            alt="Clinical procedure"
                            className="w-full h-72 md:h-80 object-cover rounded-3xl mt-10"
                        />
                    </div>
                </div>
                <div className="lg:col-span-6 order-1 lg:order-2">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#d4af37] flex items-center">
                        <span className="gdc-divider" />
                        About Galaxy Dental
                    </div>
                    <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight">
                        A calm, contemporary
                        <br />
                        <span className="italic text-[#d4af37]">
                            practice for modern Udaipur.
                        </span>
                    </h2>
                    <p className="mt-6 text-[#faf9f6]/80 leading-relaxed max-w-lg">
                        Galaxy Dental Clinic is home to
                        <strong className="text-[#faf9f6]"> Dr. Swapnil
                        Tamrakar</strong> — a Prosthodontist and Implant
                        Specialist with more than 15 years of practice and
                        over 1,000 successful implants placed. Every plan
                        starts with a conversation, a 3D intraoral scan and
                        a transparent estimate.
                    </p>
                    <p className="mt-4 text-[#faf9f6]/70 leading-relaxed max-w-lg">
                        With a conscious-sedation setup, digital
                        intraoral scanning and a warm, unhurried team — we
                        make modern, world-class dentistry feel
                        refreshingly calm.
                    </p>

                    <div className="mt-10 grid grid-cols-2 gap-6">
                        <div>
                            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">
                                In practice
                            </div>
                            <div className="font-serif-display text-4xl mt-2">
                                15+ yrs
                            </div>
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">
                                Implants placed
                            </div>
                            <div className="font-serif-display text-4xl mt-2">
                                1,000+
                            </div>
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">
                                Google reviews
                            </div>
                            <div className="font-serif-display text-4xl mt-2">
                                530+ · 4.8★
                            </div>
                        </div>
                        <div>
                            <div className="text-xs uppercase tracking-[0.25em] text-[#d4af37]">
                                Digital intraoral scanner
                            </div>
                            <div className="font-serif-display text-4xl mt-2">
                                In-house
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
